module.exports = __webpack_public_path__ + "static/media/howLongRecommended.10621675.mp3";